<template>
  <div class="pay-completion">
    <div class="container">
      <div class="pay" :class="{ error: !isSuccess }">
        <div class="state-box">
          <img
            src="~assets/img/order/icon_done_right.png"
            class="icon"
            v-if="isSuccess"
          />
          <img
            src="~assets/img/order/icon_done_wrong.png"
            class="icon"
            v-else
          />
          <p class="pay-title">{{ isSuccess ? $t.meta.paySuccess : $t.meta.payFailure }}</p>
        </div>
        <p class="error-message" v-if="!isSuccess">{{ errMsg }}</p>
        <div class="actions">
          <div class="btn" v-if="isSuccess && isLogging" @click="actionDetail">
            {{ $t.meta.viewDetail }}
          </div>
          <div class="btn" @click="backHome">{{ $t.meta.backHome }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isAPP, getPlatform } from "@/plugins/environment/type.js";
import { isProduction } from "@environment/type";
import { mapGetters } from "vuex";

export default {
  name: "payCompletion",
  data() {
    return {
      isApp: isAPP(),
      platform: getPlatform(),
      isProduction: isProduction(),
    };
  },
  computed: {
    ...mapGetters(["isLogging"]),
    queryParams() {
      //return { status: "01" };
      //return { status: "02", message: "余额不足" };
      return this.$route.query;
    },
    isSuccess() {
      return this.queryParams.status === "01";
    },
    errMsg() {
      return this.queryParams.message;
    },
    errorMsg() {
      return this.$route.query.message
        ? this.$route.query.message
        : this.$t.meta.payFailure;
    },
  },
  mounted() {
    if (this.isProduction && !this.isApp && this.platform == "ios") {
      window.location.href = "vtrack://";
    }
  },
  methods: {
    actionDetail() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerReplace, {
        isParams: false,
        path: "consumptionRecord",
        name: "consumptionRecord",
        query: [],
      });
    },
    backHome() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: this.isLogging ? "home" : "auth/login",
        query: [],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~assets/scss/var";
.pay-completion {
  .container {
    min-height: 120vh;
    background: -webkit-gradient(
      linear,
      left top,
      right bottom,
      color-stop(0%, #009ed4),
      color-stop(100%, #5029c3)
    );
    .pay {
      padding: 100px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &.error {
        .actions {
          margin-top: 15px;
        }
      }

      .state-box {
        display: flex;
        align-items: center;

        .icon {
          width: 24px;
          height: 24px;
        }

        .pay-title {
          margin: 0 0 0 10px;
          color: white;
          font-size: 20px;
          font-weight: bold;
        }
      }

      .error-message {
        color: #fffefe;
        font-size: 12px;
        margin: 10px 0 0 0;
      }

      .actions {
        display: flex;
        margin-top: 30px;

        .btn {
          height: 30px;
          width: 110px;
          border-radius: 15px;
          border: 1px solid white;
          color: #fffeee;
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;

          & + .btn {
            margin-left: 12px;
          }
        }
      }
    }
  }
}
</style>
